import {texture, MiniSignal} from "p3";
import definitions from "../../../definitions";
import Decal from "../../Decal";
import Enemy from "./Enemy";

export default class EnemySimonSays extends Enemy {
    constructor() {
        super(definitions.ENEMY_ID.SIMON_SAYS);

        this.moveSpeed = 1000;
        this.linearDamping = 6;
        this.collisionDamping = 12;

        this.collisionEnabled = false;

        this.collisionRadius = 25;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -45;

        this.colour = 0xFFFFFF;
        //this.colourTime = {current:0, max:0.6};

        this.allowDamagePushback = false;

        this.zOffset = 110;

        this.allowStrike = true;
        this.signals.struck = new MiniSignal();
    }

    init() {
        super.init();

        this._initTexture();
    }

    destroy() {
        super.destroy();
    }

    onViewAdded() {
        super.onViewAdded();

        //this._tempGraphic = new PIXI.Sprite();
        this._view.tint = 0xffffff;
        this._view.anchor.set(0.5, 0);
        this._view.y -= this._view.height;
    }

    _initTexture() {
        switch (this.uid) {
            case "simon_says_1":
                this.addViewWithTexture(texture("prop_bell_puzzle_00"));
                break;
            case "simon_says_2":
                this.addViewWithTexture(texture("prop_bell_puzzle_01"));
                break;
            case "simon_says_3":
                this.addViewWithTexture(texture("prop_bell_puzzle_02"));
                break;
            case "simon_says_4":
                this.addViewWithTexture(texture("prop_bell_puzzle_03"));
                break;
            case "simon_says_5":
                this.addViewWithTexture(texture("prop_bell_puzzle_03"));
                break;
        }
    }

    _playNoteSfx() {
        switch (this.uid) {
            case "simon_says_1":
                P3.audio.playSound("sfx_action_hit_note_00");
                break;
            case "simon_says_2":
                P3.audio.playSound("sfx_action_hit_note_01");
                break;
            case "simon_says_3":
                P3.audio.playSound("sfx_action_hit_note_02");
                break;
            case "simon_says_4":
                P3.audio.playSound("sfx_action_hit_note_03");
                break;
            case "simon_says_5":
                P3.audio.playSound("sfx_action_hit_note_03");
                break;
        }
    }

    takeDamage(amount) {
        if (!this.allowStrike)
            return;

        this.soundOut();

        this.signals.struck.dispatch(this);

        return false;
    }

    soundOut(){
        this._playNoteSfx();

        const tl = new gsap.timeline();
        tl.to(this._view, 0.2, {rotation:10*PIXI.DEG_TO_RAD, ease:Sine.easeOut});
        tl.to(this._view, 0.2, {rotation:-10*PIXI.DEG_TO_RAD, ease:Sine.easeOut});
        tl.to(this._view, 0.6, {rotation:0, ease:Elastic.easeOut});

        ////console.log('soundOut');
        //this.colourTime.current = window.dt;
    }

    update() {
        super.update();

        /*
        if (this.colourTime.current > 0) {
            this.colourTime.current += window.dt;
            if (this.colourTime.current >= this.colourTime.max) {
                this._view.tint = 0xffffff;
            }
        }*/
    }

    setColour(colour) {

        this.colour = colour;
        this._view.tint = colour;
    }


    /**
     * @param {number} state
     * @private
     */
    
    onStateEnter(state) {
        switch (state) {

            case definitions.ENEMY_STATE.IDLE: {
                
                break;
            }
        }
    }

        /**
     * @param {number} state
     */
    onStateUpdate(state) {

        switch (state) {

            case definitions.ENEMY_STATE.IDLE: {
                
                break;
            }
        }
    }

    /*
    getSpriteCopy() {
        console.log(this._view.texture.textureCacheIds[0]);
        var spr = new PIXI.Sprite(texture(this._view.texture.textureCacheIds[0].replace('.png', '')));
        spr.anchor.set(0.5);
        spr.tint = this.colour;
        return spr;
    }*/

}